const pxToRem = (number: number, baseNumber = 16): string =>
  `${number / baseNumber}rem`

export default pxToRem
